module.exports = __webpack_public_path__ + "img/icon_csg.99bf7d8.png";